import React, {useEffect} from 'react';
import {isMobile} from 'react-device-detect';
import {connect} from 'react-redux';
import {OwnershipTransferStep} from './Constant/Constant';
import {setCurrentStep, setShowPopUp, saveToHistory, resetState, fetchExistingRequests, setIsJetConnection} from './OwnershipTransferSlice';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {getContactCompanyList, setSelectedHetPay} from '../PortalsBlock/portalSlice';
import loginSubTypes from '../../../constans/loginSubTypes';
import Popup from '../../Shared/Popup/PopUp';
import OwnershipTransferPopup from './Popups/OwnershipTransferPopup';
import OwnershipTransferContactPersonMain from './OwnershipTransferContactPersonMain';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';

const OwnershipTransfer = (props) => {
  useEffect(() => {
    return () => {
      props.resetState();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [props.data.currentStep]);

  useEffect(() => {
    if (props.authentication.isAuthenticateFinish) {
      start();
    } else {
      props.showAppLoader();
    }
  }, [props.authentication]);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        const timeoutId = setTimeout(() => {
          props.saveToHistory(props.data.currentStep);
        }, 1500);

        return () => clearTimeout(timeoutId); // Cleanup on unmount or dependency change
      }
    },
    [props.data.currentStep],
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        props.saveToHistory(props.data.currentStep);
      }
    },
    [props.data.selectedActionType],
  );

  useClearStateResetFlag();

  function start() {
    if (
      props.authentication?.loginData.userDetails?.Impersonate &&
      props.authentication?.loginData.userDetails?.loginSubType == loginSubTypes.ONBEHALF
    ) {
      props.setIsJetConnection(true);
    }
    if (props.portalsBlock.hetPaysNumbers.length == 0 && !props.portalsBlock.requestCompleted) {
      loadCompanies();
    } else {
      loadNextStep();
    }
  }

  function loadNextStep(orgId) {
    if (!isMobile) {
      if (!props.data.dashboardRequestCompleted) {
        let selectedOrgId =
          orgId || props.portalsBlock.privateCompanyList?.find((c) => c.idNumber == props.portalsBlock.selectedHetPay)?.orgId;
        props.fetchExistingRequests(selectedOrgId);
      }
    } else {
      props.setCurrentStep(OwnershipTransferStep.SelectActionType);
    }
  }

  async function loadCompanies() {
    props.showAppLoader();
    await props.getContactCompanyList().then((res) => {
      //jet
      if (
        props.authentication?.loginData.userDetails?.Impersonate &&
        props.authentication?.loginData.userDetails?.loginSubType == loginSubTypes.ONBEHALF
      ) {
        const hetPay = props.authentication?.loginData?.userDetails.OrgIdNumber;
        props.setSelectedHetPay(hetPay);
        let selectedOrgId = res?.payload?.bussinessOrgList?.find((c) => c.idNumber == hetPay)?.orgId;
        loadNextStep(selectedOrgId);
      } else {
        props.setCurrentStep(OwnershipTransferStep.SelectCompany);
      }
      props.hideAppLoader();
    });
  }

  return (
    <div className='ownershipTransfer'>
      <OwnershipTransferContactPersonMain iContent={props.iContent} />
      <Popup className={`${props.data.currentPopUp} mainPopup`} showPopUp={props.data.showPopup} onClose={() => props.setShowPopUp(false)}>
        <OwnershipTransferPopup iContent={props.iContent} />
      </Popup>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
  portalsBlock: state.portalsBlock,
  authentication: state.authentication,
});

const mapDispatchToProps = {
  setShowPopUp,
  setCurrentStep,
  saveToHistory,
  getContactCompanyList,
  showAppLoader,
  hideAppLoader,
  resetState,
  fetchExistingRequests,
  setIsJetConnection,
  setSelectedHetPay,
};

export default connect(mapStateToProps, mapDispatchToProps)(OwnershipTransfer);
